import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '~/environments/environment';

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.msalConfig.auth.oidcPolicy
  },
  authorities: {
    signUpSignIn: {
      authority: environment.msalConfig.auth.oidcUrl + environment.msalConfig.auth.oidcPolicy
    }
  },
  authorityDomain: environment.msalConfig.auth.oidcDomain
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.auth.clientId, // This is the ONLY mandatory field that you need to supply.
    redirectUri: environment.msalConfig.redirectUri, // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    postLogoutRedirectUri: environment.msalConfig.postLogoutUrl
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
  },
  system: {
    /**
     * Below you can configure MSAL.js logs. For more information, visit:
     * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
     */
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {},
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: environment.gprApiConfig.scopes
};
